<mat-toolbar>
  <span class="fill-remaining-space"></span>
  @if (canCreate() && !isDownload() &&!all()) {
  <span class="create-audit">
    <button
      mat-raised-button
      [routerLink]="['new']">
      Create Audit
    </button>
  </span>
  }
  <span>
    @if (isDownload()) {
    <mat-spinner diameter="20"></mat-spinner>
    } @if (!isDownload()) {
    <button
      mat-raised-button
      (click)="exportExcel()"
      [disabled]="!unfilteredDataSource">
      Create Excel Export
    </button>
    }
  </span>
</mat-toolbar>

@if (isDefined()) {
<mat-grid-list
  cols="5"
  rowHeight="4rem">
  <mat-grid-tile>Filter by:</mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field>
      <mat-label>Title</mat-label>
      <input
        matInput
        [(ngModel)]="titleSelect"
        (ngModelChange)="filterData()" />
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field>
      <mat-label>Status</mat-label>
      <mat-select
        [(ngModel)]="statusSelect"
        (selectionChange)="filterData()">
        <mat-option value="">-- Show All --</mat-option>
        <mat-option value="Pending">Pending</mat-option>
        <mat-option value="Settled">Settled</mat-option>
        @if (all() && accessService.hasAuditorRole()) {
        <mat-option value="Finally settled">Finally settled</mat-option>
        }
        <mat-option value="Adjourned">Adjourned</mat-option>
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field>
      <mat-label>Auditee</mat-label>
      <mat-select
        [(ngModel)]="assessmentSelect"
        (selectionChange)="filterData()">
        <mat-option value="">-- Show All --</mat-option>
        @for (possibleCoordinator of possibleCoordinators; track possibleCoordinator) {
        <mat-option value="{{ possibleCoordinator }}"
          >{{ possibleCoordinator | userName | async }} {{ possibleCoordinator | azureIdStatus | async }}</mat-option
        >
        }
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field>
      <mat-label>BG</mat-label>
      <mat-select
        [(ngModel)]="bgSelect"
        (selectionChange)="filterData()">
        <mat-option value="">-- Show All --</mat-option>
        @for (possibleBg of possibleBgs; track possibleBg) {
        <mat-option value="{{ possibleBg }}">{{ possibleBg }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field>
      <mat-label>Legal Unit</mat-label>
      <mat-select
        [(ngModel)]="legalUnitSelect"
        (selectionChange)="filterData()">
        <mat-option value="">-- Show All --</mat-option>
        @for (possibleLegalUnit of possibleLegalUnits; track possibleLegalUnit) {
        <mat-option value="{{ possibleLegalUnit }}">{{ possibleLegalUnit }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field>
      <mat-label>Plant</mat-label>
      <mat-select
        [(ngModel)]="plantSelect"
        (selectionChange)="filterData()">
        <mat-option value="">-- Show All --</mat-option>
        @for (possiblePlant of possiblePlants; track possiblePlant) {
        <mat-option value="{{ possiblePlant }}">{{ possiblePlant }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field>
      <mat-label>Report Year</mat-label>
      <mat-select
        [(ngModel)]="reportYearSelect"
        (selectionChange)="filterData()">
        <mat-option value="">-- Show All --</mat-option>
        @for (possibleReportYear of possibleReportYears; track possibleReportYear) {
        <mat-option value="{{ possibleReportYear }}">{{ possibleReportYear }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <button
      mat-raised-button
      (click)="showAll()">
      Reset
    </button>
  </mat-grid-tile>
</mat-grid-list>
}

<table
  mat-table
  [dataSource]="dataSource"
  matSort
  matSortActive="reportingYear"
  matSortDirection="asc"
  class="mat-elevation-z8"
  aria-describedby="audits are shown here">
  @for (col of columns; track col) { @if (!col.custom) {
  <ng-container [matColumnDef]="col.field">
    <th
      id="status"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header>
      {{ col.title }}
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation[col.field] }}
    </td>
  </ng-container>
  } @if (col.custom === 'name') {
  <ng-container [matColumnDef]="col.field">
    <th
      id="title"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header>
      {{ col.title }}
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      @if(recommendation.assessmentCoordinatorName) {
      {{ recommendation.assessmentCoordinator | userName: recommendation.assessmentCoordinatorName | async }}
      {{ recommendation.assessmentCoordinator | azureIdStatus | async }}
      } @else {
      {{ recommendation[col.field] | userName | async }}
      {{ recommendation[col.field] | azureIdStatus | async }}
      }
    </td>
  </ng-container>
  } @if (col.custom === 'split') {
  <ng-container [matColumnDef]="col.field">
    <th
      id="others"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header>
      {{ col.title }}
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation.department }}
      {{ recommendation.legalUnit }} {{ recommendation.plant }}
      {{ recommendation.area }}
    </td>
  </ng-container>
  } }
  <tr
    mat-header-row
    *matHeaderRowDef="columnFields"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: columnFields"
    (click)="navigateToAudit(row)"
    class="item"></tr>
</table>

<mat-paginator
  [pageSizeOptions]="[10, 25, 40]"
  showFirstLastButtons />

@if (!isDefined()) {
<mat-spinner class="spinner" />
}
